import Grid from '@material-ui/core/Grid';
import {i18n2} from 'features/i18n/i18n';
import {Field} from 'formik';
import {TextField} from 'formik-material-ui';
import React from 'react';

const AddLink = () => (
  <Grid item xs={12}>
    <Field
      name="url"
      component={TextField}
      label={i18n2._('URL')}
      fullWidth
      variant="outlined"
      multiline
    />
  </Grid>
);

export default AddLink;
